import { z } from "zod"
import { CustomerSchema } from "./customer"

export const EventSchema = z.object({
  id: z.number(),
  name: z.string(),
  customer_id: z.number(),
  project_id: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  is_test: z.boolean(),
  custom_fields: z.any().nullable(),
  customer: CustomerSchema.optional(),
})

export type Event = z.infer<typeof EventSchema>
